import { useEffect, useState } from "react"

const useDelayedUnmounting = (isMounted: boolean, delayTime = 250) => {
    const [shouldRender, setShouldRender] = useState(false)

    useEffect(() => {
        let timeoutId: ReturnType<typeof setTimeout> | undefined

        if (isMounted && !shouldRender) {
            setShouldRender(true)
        } else if (!isMounted && shouldRender) {
            timeoutId = setTimeout(() => setShouldRender(false), delayTime)
        }

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId)
            }
        }
    }, [isMounted, delayTime, shouldRender])
    return shouldRender
}

export { useDelayedUnmounting }
